import {
  createFileRoute,
} from '@tanstack/react-router';

import {
  UsersConfig,
} from '#features/scout/DigitalAssistants/Settings/UsersConfig';

export const Route = createFileRoute(
  '/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings/users',
)({
  beforeLoad: () => {
    return {
      crumb: 'Users',
    };
  },
  loader: async (opts) => {
    const usersResult: any[] = await opts.context.queryClient.ensureQueryData({
      queryKey: [
        'reporter',
        'users',
      ],
    });
    const availableResult: any[] = await opts.context.queryClient.ensureQueryData({
      queryKey: [
        'reporter',
        'users',
        'available',
      ],
    });
    const users = usersResult.filter(item => item.email !== opts.context.auth.user?.profile.email);
    const available = availableResult.filter(item => item.email !== opts.context.auth.user?.profile.email);
    return {
      userData: users,
      availableUserData: available,
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  const props = Route.useLoaderData();
  return (
    <UsersConfig
      { ...props }
    />
  );
}
